import React, { useMemo } from "react"

import { AvailableAgent, AvailableAgentContext } from "@plugins/providers/agent/AvailableAgentContext"

import { useUserSession } from "@session/UserSession"

interface AvailableAgentProviderProps {
    children: React.ReactNode
}
export function AvailableAgentProvider({ children }: Readonly<AvailableAgentProviderProps>) {
    const { client } = useUserSession()
    const search = useMemo(() => {
        return new AvailableAgent(client)
    }, [client])

    return <AvailableAgentContext.Provider value={search}>{children}</AvailableAgentContext.Provider>
}
